import React, { useContext, useEffect, useRef, useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import { MyContext } from '../context/Context';
import { add_city_api, city_delete_api, city_details_api, city_update_api } from '../api/api';
import { Link, useLocation, useParams } from 'react-router-dom';
import FormError from '../components/FormError';
import { toast } from 'react-toastify';

function City() {
    const location = useLocation();
    const stateId = location.state?.stateId;

    const add_close_Ref = useRef(null);
    const update_close_Ref = useRef(null);
    const { stateList, state_details_api_call } = useContext(MyContext);
    const [cityList, setCityList] = useState([]);
    const [inputCity, setInputCity] = useState({
        state_id: stateId ? stateId : '',
        city_name: "",
        city_id: "",
    });
    const [formError, setFormError] = useState({
        city_name: "",
    })

    // find state
    const find_state = stateList && stateList.find((state) => state?.state_id === stateId)


    useEffect(() => {
        state_details_api_call();
    }, []);

    useEffect(() => {
        fetch_city_details();
    }, []);


    const handle_change = (e) => {
        const { name, value } = e.target;
        setInputCity({
            ...inputCity,
            [name]: value
        });
    };


    //add city
    const add_city_api_call = async () => {
        const errors = {};
        if (!inputCity.city_name) {
            errors.city_name = 'Please enter city name!'
        }
        setFormError(errors);

        if (Object.keys(errors).length !== 0) {
            return;
        }
        try {
            const res = await add_city_api(inputCity);
            if (res.status === 200) {
                fetch_city_details();
                setInputCity(prevState => ({ ...prevState, city_name: "" }));
                toast.success("City Added Successfully");
                add_close_Ref.current.click();
            }
        } catch (error) {
            console.error("Add city API error:", error);
            if (error.response && error.response.data && error.response.data.errors.length > 0) {
                const errors = {};
                // Map through the errors array and populate the errors object
                error.response.data.errors.forEach(err => {
                    errors[err.key] = err.message; // Assuming each error has 'name' and 'message'
                });
                setFormError(errors);
            }
        }
    };



    //fetch city details
    const fetch_city_details = async () => {
        try {
            const res = await city_details_api({state_id: stateId});
            if (res.status === 200) {
                setCityList(res.data.data);
            }
        } catch (error) {
            console.error("City details API error:", error);
        }
    };


    // city delete
    const city_delete_api_call = async (id) => {
        try {
            const res = await city_delete_api(id);
            if (res.status === 200) {
                toast.success("City Deleted Successfully");
                fetch_city_details();
                console.log(res)
            }
        } catch (error) {
            if(error.status === 400){
                toast.error(error.data.message);
            }
            console.error("city delete api error", error);
        }
    };



    // selected city
    const selected_city = (id) => {
        const filter_city = cityList.filter((city) => city.city_id == id);
        setInputCity(filter_city[0]);
    };

    // city update
    const city_update_api_call = async () => {
        const errors = {};
        if (!inputCity.city_name) {
            errors.city_name = 'Please Enter City Name!'
        }
        setFormError(errors);

        if (Object.keys(errors).length !== 0) {
            return;
        }
        try {
            const res = await city_update_api(inputCity);
            if (res.status === 200) {
                fetch_city_details();
                toast.success("City Updated Successfully");
                update_close_Ref.current.click();
            }
        } catch (error) {
            console.error("city update api error", error);
            if (error.response && error.response.data && error.response.data.errors.length > 0) {
                const errors = {};
                // Map through the errors array and populate the errors object
                error.response.data.errors.forEach(err => {
                    errors[err.key] = err.message; // Assuming each error has 'name' and 'message'
                });
                setFormError(errors);
            }
        }
    };

    const clearError = () => {
        const clearedErrors = {};

        Object.keys(formError).forEach(field => {
            clearedErrors[field] = "";
        });

        setFormError(clearedErrors);
    }

    return (
        <div className="wrapper">
            <Navbar />
            <Sidebar />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2 d-flex">
                            <div className="col-12 col-xl-6 d-flex flex-column flex-sm-row">
                                <h1 className="m-0 mr-3">Cities For</h1>
                                <select
                                    className="custom-select mb-3"
                                    style={{ width: "300px" }}
                                    name="state_id"
                                    value={stateId}
                                    onChange={handle_change}
                                    disabled
                                >
                                    <option value="">Select state...</option>
                                    {stateList && stateList.map((state, index) => (
                                        <option value={state?.state_id} key={index} >{state?.state_name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col d-flex justify-content-end mb-3 mb-xl-0">
                                <span className='text-sm'>
                                    <Link to="/dashboard">Dashboard</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <Link to="/state">{find_state?.state_name}</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <span>Cities</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex justify-content-end'>
                        <button
                            className='btn btn-naariyal-green'
                            data-toggle="modal"
                            data-backdrop="static"
                            data-target="#add-city"
                            onClick={() => {
                                setInputCity({
                                    ...inputCity,
                                    city_name: "",
                                    city_id: "",
                                })
                            }}
                        >
                            <i className="nav-icon fas fa-plus mr-2"></i>
                            Add City
                        </button>
                    </div>
                </div>



                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table id="example2" className="table table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>City</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {cityList.length > 0 && cityList.map((city, index) => (
                                                        <tr key={index}>
                                                            <td className='col-2'>{index + 1}</td>
                                                            <td className='col-6'>{city?.city_name}</td>
                                                            <td>
                                                                <Link
                                                                    to='/area'
                                                                    state={{
                                                                        cityId: city?.city_id,
                                                                        stateId: stateId
                                                                    }}
                                                                    className="btn btn-naariyal-green mr-3 mb-3 mb-lg-0"
                                                                >
                                                                    Manage Areas
                                                                </Link>
                                                                <div className="btn-group">
                                                                    <button type="button" className="btn btn-naariyal-green dropdown-toggle" data-toggle="dropdown">Action</button>

                                                                    <div className="dropdown-menu" role="menu">
                                                                        <a
                                                                            className="dropdown-item text-info"
                                                                            data-toggle="modal"
                                                                            data-backdrop="static"
                                                                            data-target="#update-city"
                                                                            onClick={() => selected_city(city?.city_id)}
                                                                        >
                                                                            <i className="nav-icon fas fa-pencil mr-2"></i>
                                                                            Update
                                                                        </a>
                                                                        <div className="dropdown-divider"></div>
                                                                        <a
                                                                            className="dropdown-item text-danger"
                                                                            onClick={() => city_delete_api_call(city?.city_id)}
                                                                        >
                                                                            <i className="nav-icon fas fa-trash-alt mr-2"></i>
                                                                            Delete
                                                                        </a>
                                                                    </div>
                                                                </div>

                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* add city modal */}
                    <div className="modal fade" id="add-city" tabIndex={-1} role="dialog" aria-labelledby="addCityModal" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header border-0">
                                    <h5>
                                        Add City
                                    </h5>
                                    <button type="button" onClick={clearError} className="close" data-dismiss="modal" aria-label="Close" ref={add_close_Ref}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="input-group">
                                        <div className='w-100'>
                                            <label htmlFor="state_name">State</label>
                                            <select
                                                className="custom-select mb-3"
                                                name="state_id"
                                                id='state_name'
                                                value={stateId}
                                                onChange={handle_change}
                                                disabled
                                            >
                                                <option value="">Select state...</option>
                                                {stateList && stateList.map((state, index) => (
                                                    <option value={state?.state_id} key={index}>{state?.state_name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className='w-100'>
                                            <label htmlFor="city_name">City</label>
                                            <input
                                                type="text"
                                                id='city_name'
                                                className="form-control"
                                                placeholder="Enter City"
                                                name='city_name'
                                                value={inputCity.city_name}
                                                onChange={handle_change}
                                            />
                                            <FormError>
                                                {formError.city_name ? formError.city_name : ''}
                                            </FormError>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer border-0">
                                    <button
                                        type="button"
                                        className="btn btn-naariyal-green w-25 m-auto"
                                        onClick={add_city_api_call}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* update city modal */}
                    <div className="modal fade" id="update-city" tabIndex={-1} role="dialog" aria-labelledby="addCityModal" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header border-0">
                                    <h5>Update City</h5>
                                    <button type="button" onClick={clearError} className="close" data-dismiss="modal" aria-label="Close" ref={update_close_Ref}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="input-group">
                                        <div className='w-100'>
                                            <label htmlFor="state_id">State</label>
                                            <select
                                                className="custom-select mb-3"
                                                id='state_id'
                                                name="state_id"
                                                value={inputCity.state_id}
                                                onChange={handle_change}
                                                disabled
                                            >
                                                <option value="">Select state...</option>
                                                {
                                                    stateList && stateList.map((state, index) => (
                                                        <option value={state?.state_id} key={index}>{state?.state_name}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                        <div className='w-100'>
                                            <label htmlFor="city_name">City</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter City"
                                                name='city_name'
                                                value={inputCity?.city_name}
                                                onChange={handle_change}
                                            />
                                            <FormError>
                                                {formError.city_name ? formError.city_name : ''}
                                            </FormError>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer border-0">
                                    <button
                                        type="button"
                                        className="btn btn-naariyal-green w-25 m-auto"
                                        onClick={() => city_update_api_call(inputCity?.city_id)}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
            <Footer />
        </div>
    );
}

export default City;
